/**
 * Zamiana obiektu błędu na stringa
 *
 * @export
 * @param {*} error to może być string, błąd js, błąd KSAT, błąd MDOK
 * @return {string}
 */
export function stringifyError(error: any): string {
  console.log('stringifyError:', error);
  if (typeof error === 'string') {
    return error;
  }
  let errorStr = '';

  if (error.message) {
    errorStr += error.message.replace(/(Error: )?GraphQL error:/gi, '').trim();
    return errorStr;
  }

  if (error.name === 'ResponseError') {
    errorStr +=
      error.response?.result?.return?.TrescBledu || error.response?.result?.rawResponse || JSON.stringify(error);
    return errorStr;
  }

  if (error.code) {
    errorStr += `${error.code}: `;
  }
  errorStr += `<small>${JSON.stringify(error)}</small>`;

  return errorStr;
}
